import { BaseStore, hookFactory } from '@platform/template';
import { PubSub, getFxExpression, getBusinessInfo, setTimeValue, getBaseTime, localTimeToServer, isFunction, isArray, ViewModel, localeLang, getAppReqParam, getDimensionCode, isWrong, clearOneTypeToast } from '@platform/api';
import { getFunctionValue } from '@platform/base';
import CardContainer from '../CardContainer/index';
const { useCardContainer } = CardContainer;
const FORMCOMPLETE = 'areaChangeComplete';

function merge(target, ...rest) {
    return target;
}

function setInitialProperty(target, prop, value) {
    !target && (target = {});
    if (!target.hasOwnProperty(prop)) {
        target[prop] = value;
    }
    return value;
}

// number 类型的默认值判断下
function getNumberValue(value) {
    !value && (value = {});
    let numberValue = value.value;
    numberValue = isNaN(numberValue) ? '' : numberValue;
    value = { ...value, value: numberValue };
    return value;
}

const SKIP_VALIDATE_TYPE = new Set(['checkbox_switch', 'switch', 'switch_browse']);
const TIME_TYPE = new Set(['datepicker', 'datetimepicker', 'timepicker', 'rangepicker', 'datePickerNoTimeZone', 'NCTZDatePickerStart', 'NCTZDatePickerRangeDay', 'NCTZDatePickClientHourTime', 'NCTZDatePickClientTime', 'NCTZDatePickerEnd']);
const BUSINESSDATE = getBusinessInfo()?.businessDate;
class FormStore extends BaseStore {
    // 初始化 Store 有序Store 根据表单
    store = { cardContainerStore: useCardContainer() };

    // 属性唯一标志 避免与表单ID冲突
    items = '_FORM_ITEMS_';

    // 关键信息区 唯一标识
    formCardItems = '_FORM_CARD_ITEMS_'

    // 布局
    layout = Symbol('form layout');

    //状态
    status = Symbol('form status');

    getHooks = () => ({
        getItemValue: this.getItemValue,
        getAllFormValue: this.getAllFormValue,
        setItemValue: this.setItemValue,
        setAllFormValue: this.setAllFormValue,
        setDefaultValueFromMeta: this.setDefaultValueFromMeta,
        setCtx: this.setCtx,
        reset: this.reset,
        setWrapper: this.setWrapper,
        getStatus: this.getStatus,
        setStatus: this.setStatus,
        closeArea: this.closeArea,
        openArea: this.openArea,
        emptyAllFormValue: this.emptyAllFormValue,
        setMeta: this.setMeta,
        cancel: this.cancel,
        countFormWidth: this.countFormWidth,
        setItemAttribute: this.setItemAttribute,
        getItemAttribute: this.getItemAttribute,
        isCheckNow: this.isCheckNow,
        replaceItem: this.replaceItem,
        getMetaItems: this.getMetaItems,
        getOldValue: this.getOldValue,
        setOldValue: this.setOldValue,
        forceUpdate: this.forceUpdate,
        setAreaVisible: this.setAreaVisible,
        getAreaVisible: this.getAreaVisible,
        clearFormValue: this.clearFormValue,
        setEventListener: this.setEventListener,
        getEventListener: this.getEventListener,
        setCardItemAttribute: this.setCardItemAttribute,
        getCardItem: this.getCardItem,
        // 内部使用方法
        getInnerHooks: this.getInnerHooks,
        clearAutoFocus: this.clearAutoFocus,
        getFormItem: this.getFormItem,
        clearAllVerify: this.clearAllVerify

    });

    // =========== 内部使用方法 ===========
    getInnerHooks = () => {
        return {
            setInitialValues: this.setInitialValues,
            getItem: this.getItem,
            getStore: this.getStore,
            setStore: this.setStore,
            getSingleForm: this.getSingleForm,
            getFormItem: this.getFormItem,
            getAllFormItem: this.getAllFormItem,
            getFormRelations: this.getFormRelations,
            getFormList: this.getFormList,
            getLayout: this.getLayout,
            setLayout: this.setLayout,
            getFormTabs: this.getFormTabs,
            setFormTabs: this.setFormTabs,
            countFormWidth: this.countFormWidth,
            setJson: this.setJson,
            getJson: this.getJson,
            getReplaceItem: this.getReplaceItem,
            initMeta: this.initMeta,
        };
    };

    getStore = path => {
        return this.get(path);
    };

    setStore = (path, value, shouldUpdate = true) => {
        let newValue = this.set(path, value);
        shouldUpdate && this.forceUpdate(() => {
            PubSub.publish(FORMCOMPLETE, true);
        });
        return newValue;
    };

    // 初始化meta数据 mergeStore  转化meta
    setInitialValues = (params = {}) => {
        let { meta, formId, context, pageScope = {}, clearStoreMeta = false } = params;
        const timeFun = setTimeValue();
        // await Promise.resolve(() => {});
        if (!meta || Object.keys(meta).length === 0) { return; }

        const { formrelation, formassociatedrelation, pageid, formInfoGroupRelation = [], coreDataItems = [], corerelation = {} } = meta;
        let isTabsForm = false;
        let arr = [formId],
            tabsId = [formId],
            formRelation = {},
            formitems = {},
            infoGroup = {},
            store = {};
        // 原始数据 
        infoGroup.origin = [];
        // 区域关系
        infoGroup.areaRelation = {};

        // 排个序吧
        formInfoGroupRelation.sort((a, b) => {
            if (!a) {
                return 1;
            }
            if (!b) {
                return -1;
            }
            if (!a && !b) {
                return 0;
            }
            // return areaA.order - areaB.order;
            return a.position - b.position;
        });

        // 信息组 获取关系，渲染时好进行判断
        formInfoGroupRelation.forEach((info, i) => {
            let { areacode, itemcode = 'first', direction, items = [] } = info;
            items = typeof items === 'string' ? JSON.parse(items) : items;
            let areaRelation = infoGroup.areaRelation[areacode] || {};

            areaRelation.fieldRelation = areaRelation.fieldRelation || {};
            areaRelation.followRelation = areaRelation.followRelation || {};
            areaRelation.followRelation[itemcode] = areaRelation.followRelation[itemcode] || [];
            items.forEach(item => {
                // 字段关系
                areaRelation.fieldRelation[item] = item;
            });
            let newInfo = {
                ...info,
                items,
            };
            // 原始数据
            infoGroup.origin.push(newInfo);
            // 跟随关系
            areaRelation.followRelation[itemcode].push(newInfo);
            // 区域关系
            infoGroup.areaRelation[areacode] = areaRelation;
        });

        // 关键信息区
        if (corerelation[formId]) {
            let formItems = {};
            corerelation[formId].forEach(formCardId => {
                formItems[formCardId] = {};
                let itemsFromStore = this.getStore([this.formCardItems, formCardId]);
                let formCardItems = meta[formCardId]?.items || [];
                formCardItems.forEach(formItem => {
                    // disabled visible required verify要通过api设值。
                    let { disabled, visible, required, verify, ...propsToPass } = formItem;
                    if (clearStoreMeta) {
                        formItems[formCardId][formItem.attrcode] = {
                            __origin__: {},
                            ...propsToPass,
                            __dirty__: itemsFromStore?.[formItem.attrcode]?.['__dirty__'] || {},
                            __controlRule__: itemsFromStore?.[formItem.attrcode]?.['__controlRule__'] || {},
                        };
                    } else {
                        formItems[formCardId][formItem.attrcode] = { __origin__: {}, ...itemsFromStore?.[formItem.attrcode], ...propsToPass };
                    }
                    ['disabled', 'visible', 'required', 'verify'].forEach(attribute => {
                        let isDirty = this.getStore([this.formCardItems, formCardId, formItem.attrcode, '__dirty__', attribute]);
                        let isControlRule = this.getStore([this.formCardItems, formCardId, formItem.attrcode, '__controlRule__', attribute]);
                        if (isDirty) {
                            // 取store
                            formItems[formCardId][formItem.attrcode][attribute] = itemsFromStore?.[formItem.attrcode]?.[attribute];
                        } else {
                            // 取meta
                            formItems[formCardId][formItem.attrcode][attribute] = formItem[attribute];
                        }
                        formItems[formCardId][formItem.attrcode]['__origin__'][attribute] = formItem[attribute];
                    });
                });
            });
            // 保存上次容器存值 假如存在就替换
            store[this.formCardItems] = { ...(this.getStore([this.formCardItems]) || {}), ...formItems };
        }

        console.log(infoGroup, 'setInitialValues-infoGroup');

        // 核心数据
        let cardContainerStore = this.store['cardContainerStore'];
        if (coreDataItems.length && cardContainerStore) {
            let tempMetaItems = [];
            coreDataItems.forEach(item => {
                if (item.areacode === formId) {
                    tempMetaItems.push(item);
                }
            });
            cardContainerStore.setMeta({ [formId]: { items: tempMetaItems } }, formId, false);
        }
        // 存在多页签表单时  进行页签数据合并
        if (formassociatedrelation && formassociatedrelation.hasOwnProperty(formId) && Array.isArray(formassociatedrelation[formId].formtabs)) {
            let newTabsId = formassociatedrelation[formId].formtabs;
            // 过滤下不展示的页签
            tabsId = newTabsId.filter(tabId => meta[tabId]?.areaVisible !== false);
            arr = tabsId;
            isTabsForm = true;
        }
        // 存在子表时 进行子表数据合并
        if (formrelation) {
            if (isTabsForm) {
                let result = [];
                // 遍历主表，找子表
                arr.map(item => {
                    result.push(item);
                    if (Array.isArray(formrelation[item])) {
                        result = result.concat(formrelation[item]);
                        formRelation[item] = formrelation[item];
                    }
                    return item;
                });
                arr = result;
            } else {
                if (Array.isArray(formrelation[formId])) {
                    arr = arr.concat(formrelation[formId]);
                }
            }
        }

        arr.forEach(item => {
            // 判断 moduletype 为 form 再进行数据转换
            if (meta[item].moduletype === 'form') {
                let { items, status, isunfold, areaVisible, ...others } = meta[item];

                // 由于核心数据组对快捷键影响，需要调整下模板字段顺序
                const currentInfoGroup = infoGroup && infoGroup.areaRelation[item];
                const currentFieldRelation = currentInfoGroup && currentInfoGroup.fieldRelation;
                let baseItems = [];
                let infoGroupItems = {};
                items && items.forEach(element => {
                    let { attrcode } = element;
                    // 信息组内元素(字段关系)
                    if (currentFieldRelation && currentFieldRelation[attrcode]) {
                        infoGroupItems[attrcode] = element;
                    } else {
                        baseItems.push(element);
                    }
                });
                let finalItems = [];
                // 调整顺序
                baseItems.forEach(element => {
                    let { attrcode } = element;
                    let currentFollow = currentInfoGroup && currentInfoGroup.followRelation[attrcode];
                    if (currentFollow) {
                        let before = [];
                        let after = [];
                        currentFollow.forEach(info => {
                            info.items = info.items.filter(i => infoGroupItems[i]);
                            let { items, direction, wordwrap } = info;
                            // 渲染信息组内的项
                            if (direction === 'before') {
                                items.forEach(code => {
                                    before.push(infoGroupItems[code]);
                                });
                            } else {
                                items.forEach(code => {
                                    after.push(infoGroupItems[code]);
                                });
                            }
                        });
                        finalItems = [...finalItems, ...before, element, ...after];
                    } else {
                        finalItems.push(element);
                    }
                });
                // 重新赋值
                meta[item].items = items = finalItems;

                // 初始化 status
                if (formId === item) {
                    // 已经用过API设置 status 不再取meta上status状态
                    if (!store[this.status]) {
                        store[this.status] = this.getStore([this.status]) || status || 'browse';
                    }
                }

                store[item] = {
                    ...others,
                    items: [],
                    // isunfold、areaVisible也可以通过api设值
                    isunfold: this.getStore([item, '__dirty__'])?.hasOwnProperty('isunfold') ? this.getStore([item, 'isunfold']) : isunfold,
                    areaVisible: this.getStore([item, '__dirty__'])?.hasOwnProperty('areaVisible') ? this.getStore([item, 'areaVisible']) : areaVisible,
                    __dirty__: this.getStore([item, '__dirty__']),
                };

                let itemsFromStore = this.getStore([this.items]);
                store["_attachment"] = store["_attachment"] || [];
                items.forEach(formItem => {
                    if (formItem?.itemtype === 'attachment') {
                        store["_attachment"].push(formItem.attrcode);
                    }
                    formItem['belongTo'] = item;
                    // 如果已经进行过出初始化 从新setMeta 不会初始化value 其他属性根据meta生成
                    // 兼容情况 已经存在fieldvalue 说明已经在上次setmeta时进行了fieldvalue初始化、为了兼容不在进行初始化、正常情况应该业务组每次setmeta都根据meta生成初始值fieldvalue
                    if (!this.getStore([this.items, formItem.attrcode, 'fieldValue']) || (this.getStore([this.items, formItem.attrcode, 'fieldValue'])?.isTemplateDefaultValue && store[this.status] === 'add')) {
                        //设置默认值
                        let initialvalue = null;
                        if (store[this.status] === 'add') {
                            // 判断下模板返回的 initialvalue ，如果是空对象，按照之前的 null 处理
                            // let isEmptyObj = JSON.stringify(formItem.initialvalue) === '{}'
                            let isEmptyObj = Object.keys(formItem.initialvalue || {}).length === 0 && (formItem.initialvalue || {}).constructor === Object;
                            // 加一个字段 isTemplateDefaultValue 只有在设置默认值的时候会放进去，可以用这个字段来判断当前字段的值是不是默认值，如果是默认值，可以被新的默认值覆盖
                            // 通过任何方法调用 setItemValue 都会把这个属性冲掉
                            initialvalue = isEmptyObj ? null : formItem.initialvalue ? { ...formItem.initialvalue, isTemplateDefaultValue: true } : null;
                        }
                        if (formItem.itemtype === 'checkbox_switch' || formItem.itemtype === 'switch') {
                            let defaultValue = initialvalue || {
                                display: (this.getStore(['json']) || {})['page-form-0004'],
                                value: false,
                            };
                            let templateValue = initialvalue || {
                                display: null,
                                value: null,
                            };
                            // isuserdef 用户自定义属性 组件默认值不生效，模板默认值生效
                            initialvalue = formItem.isuserdef ? templateValue : defaultValue;
                        } else if (TIME_TYPE.has(formItem.itemtype)) {
                            initialvalue = this.getTimeTypeValue(initialvalue, formItem, timeFun);
                        } else if (formItem.itemtype === 'refer') {
                            // 参照组件 fx 函数处理 如 “#mainorg#""
                            initialvalue = getFxExpression(initialvalue || {}, context);
                        } else if (formItem.itemtype === 'number') {
                            // 数值类型 处理下
                            initialvalue = getNumberValue(initialvalue || {});
                        } else {
                            initialvalue = initialvalue || {
                                display: null,
                                value: null,
                            };
                        }

                        formItem['fieldValue'] = initialvalue;
                        formItem['formOldValues'] = initialvalue.value ? { value: initialvalue.value } : { value: null };
                        formItem['formBack'] = initialvalue;
                        //多语字段初始化
                        if (formItem.itemtype === 'residtxt' && Array.isArray(formItem.languageMeta)) {
                            formItem.languageMeta.map(i => {
                                let index = i.index == '1' ? '' : i.index;
                                return formItem.attrcode + index;
                            }).forEach(i => {
                                if (i !== formItem.attrcode) {
                                    formitems[i] = {
                                        fieldValue: {
                                            display: '',
                                            value: '',
                                        },
                                    };
                                }
                            });
                        }
                    } else {
                        //字段存在 不需要重新初始fieldvalue 
                        formItem['fieldValue'] = this.getStore([this.items])[formItem.attrcode] && this.getStore([this.items])[formItem.attrcode]['fieldValue'];
                    }

                    // disabled visible required verify要通过api设值。
                    let { disabled, visible, required, verify, ...propsToPass } = formItem;
                    // 每次setMeta时重置默认值
                    // 值校验，枚举型，可选择手机号校验、身份证校验、电子邮箱校验、自定义校验。
                    // 这里还得再改改，正则的字段不存在模板字段里了，要从layout里取
                    // 
                    if (clearStoreMeta) {
                        formitems[formItem.attrcode] = {
                            __origin__: {},
                            initialvalue: null,
                            __dirty__: itemsFromStore?.[formItem.attrcode]?.['__dirty__'] || {},
                            __controlRule__: itemsFromStore?.[formItem.attrcode]?.['__controlRule__'] || {},
                            ...propsToPass
                        };
                    } else {
                        formitems[formItem.attrcode] = { __origin__: {}, ...itemsFromStore?.[formItem.attrcode], initialvalue: null, ...propsToPass };
                    }
                    ['disabled', 'visible', 'required', 'verify'].forEach(attribute => {
                        let isDirty = this.getStore([this.items, formItem.attrcode, '__dirty__', attribute]);
                        let isControlRule = this.getStore([this.items, formItem.attrcode, '__controlRule__', attribute]);
                        if (isDirty) {
                            // 取store
                            formitems[formItem.attrcode][attribute] = itemsFromStore?.[formItem.attrcode]?.[attribute];
                        } else {
                            // 取meta
                            formitems[formItem.attrcode][attribute] = formItem[attribute];
                        }
                        formitems[formItem.attrcode]['__origin__'][attribute] = formItem[attribute];
                    });

                    // 校验字段
                    formItem['verify'] = true;
                    store[item].items.push(formItem.attrcode);

                    if (formItem.languageMeta && Array.isArray(formItem.languageMeta)) {
                        // let langRelation = languageMeta.reduce((lang, { index }) => {
                        //     let realCode = index == 1 ? attrcode : attrcode + index;
                        //     lang[realCode] = {
                        //         current: lang.languageCode === localeLang,
                        //     };
                        //     return lang;
                        // }, {});
                        let main = null;
                        let current = null;
                        let langRelation = formItem.languageMeta.reduce((lang, { languageCode, index }) => {
                            let realCode = formItem.attrcode + index;
                            if (index == 1 || index == '') {
                                // 主语言值
                                // lang.main = realCode;
                                main = realCode;
                            }
                            // 当前语音
                            if (languageCode === localeLang) {
                                // lang.current = realCode;
                                // lang[realCode] = formItem.attrcode;
                                current = realCode;
                            }
                            return lang;
                        }, {});
                        // current && (langRelation[current] = main ? main : formItem.attrcode); 
                        current && (langRelation[formItem.attrcode] = current);
                        formitems['langRelation'] = { ...(formitems['langRelation'] || {}), ...langRelation };
                    }
                });
            }
        });

        if (clearStoreMeta) {
            let oldFormStoreItems = this.getStore([this.items]) || {};
            let oldFormItems = new Set(Object.keys(oldFormStoreItems));
            let newFormItems = new Set(Object.keys(formitems));
            let result = {};
            // 旧的
            oldFormItems.forEach(item => {
                if (!newFormItems.has(item)) {
                    this.getStore([this.items])[item].visible = false;
                    result[item] = this.getStore([this.items])[item];
                }
            })
            // 新的
            newFormItems.forEach(item => {
                result[item] = formitems[item];
            })
            store[this.items] = result;
        } else {
            // 保存上次容器存值 假如存在就替换
            store[this.items] = { ...(this.getStore([this.items]) || {}), ...formitems };
        }
        // NCC-198750 setMeta以后删除多余的item
        // let storeItems = this.getStore([this.items]) || {};
        // for (const key in storeItems) {
        //     if (Object.hasOwnProperty.call(storeItems, key)) {
        //         if (!formitems[key]) delete storeItems[key];
        //     }
        // }
        // store[this.items] = { ...storeItems, ...formitems };

        store[this.layout] = this.getStore([this.layout]) || {
            width: 50,
            column: 2,
        };

        // 所有表ID
        store.formList = arr;
        // 页签表ID
        store.tabsId = tabsId;
        // 主表ID
        store.mainId = formId;
        // 主子表关系
        store.formRelation = formRelation;
        // 页签选中
        store.activeTab = tabsId[0];
        // 是否多页签表单
        store.isTabsForm = isTabsForm;
        // 信息组
        store.infoGroup = infoGroup;

        // pageid
        store.pageid = pageid;

        // meta
        store.meta = meta;

        // context
        store.context = context;

        //是否主表单
        store.isMainCode = formId === meta.headcode ? true : false;
        // 获取当前页面设置的维度字段
        let dimensionCodes = getDimensionCode(pageScope.dimensionPageCode) || [];
        // 在 store 存储维度字段
        store.__dimension = dimensionCodes;

        this.store = Object.assign(this.store, store);
        this.hasRender = true;
        console.log(`Form ${formId}'s store: `, this.store);
        if (store[this.status] === 'add') {
            pageScope?.metaChange?.requestMetaByDimension(formId, null, {
                appcode: meta && meta[formId]?.appcode,
                pagecode: meta && meta[formId]?.pagecode,
            });
        }

    };

    // 领域调用此方法根据最新的模板数据设置默认值
    setDefaultValueFromMeta = (params = {}) => {
        let { formId, pageScope, exceptArr } = params;
        const meta = this.getStore('meta');
        const context = this.getStore('context');
        const timeFun = setTimeValue();
        const result = {}; // 存储最后要设默认值的字段和值
        if (!meta || Object.keys(meta).length === 0) { return; }

        const { formrelation, formassociatedrelation } = meta;
        let isTabsForm = false;
        let arr = [formId],
            tabsId = [formId];
        // 存在多页签表单时  进行页签数据合并
        if (formassociatedrelation && formassociatedrelation.hasOwnProperty(formId) && Array.isArray(formassociatedrelation[formId].formtabs)) {
            let newTabsId = formassociatedrelation[formId].formtabs;
            // 过滤下不展示的页签
            tabsId = newTabsId.filter(tabId => meta[tabId]?.areaVisible !== false);
            arr = tabsId;
            isTabsForm = true;
        }
        // 存在子表时 进行子表数据合并
        if (formrelation) {
            if (isTabsForm) {
                let tabFormResult = [];
                // 遍历主表，找子表
                arr.map(item => {
                    tabFormResult.push(item);
                    if (Array.isArray(formrelation[item])) {
                        tabFormResult = tabFormResult.concat(formrelation[item]);
                    }
                    return item;
                });
                arr = tabFormResult;
            } else {
                if (Array.isArray(formrelation[formId])) {
                    arr = arr.concat(formrelation[formId]);
                }
            }
        }

        arr.forEach(item => {
            // 判断 moduletype 为 form 再进行数据转换
            if (meta[item].moduletype === 'form') {
                let { items = [] } = meta[item];
                items.forEach(formItem => {
                    // 已经存在 fieldValue 的不设置默认值
                    if (isWrong(this.getStore([this.items, formItem.attrcode, 'fieldValue', 'value'])) && !exceptArr?.includes(formItem.attrcode)) {
                        //设置默认值
                        let isEmptyObj = Object.keys(formItem.initialvalue || {}).length === 0 && (formItem.initialvalue || {}).constructor === Object;
                        let initialvalue = isEmptyObj ? null : formItem.initialvalue || null;
                        if (formItem.itemtype === 'checkbox_switch' || formItem.itemtype === 'switch') {
                            let defaultValue = initialvalue || {
                                display: (this.getStore(['json']) || {})['page-form-0004'],
                                value: false,
                            };
                            let templateValue = initialvalue;
                            // isuserdef 用户自定义属性 组件默认值不生效，模板默认值生效
                            initialvalue = formItem.isuserdef ? templateValue : defaultValue;
                        } else if (TIME_TYPE.has(formItem.itemtype)) {
                            initialvalue = initialvalue ? this.getTimeTypeValue(initialvalue, formItem, timeFun) : null;
                        } else if (formItem.itemtype === 'refer') {
                            // 参照组件 fx 函数处理 如 “#mainorg#""
                            initialvalue = initialvalue ? getFxExpression(initialvalue, context) : null;
                        } else if (formItem.itemtype === 'number') {
                            // 数值类型 处理下
                            initialvalue = initialvalue ? getNumberValue(initialvalue) : null;
                        } else {
                            initialvalue = initialvalue;
                        }
                        initialvalue && (result[formItem.attrcode] = initialvalue);
                    }
                });
            }
        });
        this.setAllFormValue(result, false, false, null, null, pageScope)
    };

    // 获取当前编辑性
    getStatus = () => {
        return this.get([this.status]);
    };

    // 设置当前编辑性
    setStatus = value => {
        let oldStatus = this.get([this.status]);
        let status = this.setStore([this.status], value);
        if (oldStatus !== "browse" && value == "browse") {
            clearOneTypeToast("danger");
        }
        if (oldStatus !== value) {
            let eventListenerObj = this.getEventListener();
            for (const key in eventListenerObj) {
                if (Object.hasOwnProperty.call(eventListenerObj, key)) {
                    const callback = eventListenerObj[key];
                    if (key === 'statusChange' && Array.isArray(callback)) {
                        callback.forEach(fun => {
                            typeof fun === 'function' && fun(value);
                        });
                    }
                }
            }
        }
        return status;
    };

    // 获取布局
    getLayout = () => {
        return this.get([this.layout]);
    };

    // 从新计算布局
    setLayout = value => {
        let layout = this.setStore([this.layout], value);
        return layout;
    };

    // 获取一组表单
    getSingleForm = id => {
        return this.get([id, 'items']);
    };

    // 获取单个数据
    getFormItem = name => {
        return this.get([this.items, name]);
    };

    // 获取所有数据
    getAllFormItem = () => {
        return this.get([this.items]);
    };

    getFormRelations = () => {
        return this.get('formRelation');
    }

    getFormList = () => {
        return this.get('formList');
    }

    //  设置activeTab
    setFormTabs = id => {
        let activeTab = this.setStore(['activeTab'], id);
        return activeTab;
    }

    // 获取activeTab
    getFormTabs = () => {
        return this.get(['activeTab']);
    }
    // Form 宽度自适应
    countFormWidth = (e, width) => {
        if (!width) {
            let name = this.get(['mainId']);
            let ele = document.getElementById(name);
            if (ele) {
                width = ele.offsetWidth;
            }
        }

        //优化效率：默认是4列，宽度在4列范围内不再渲染
        let formItemInfo = { width: 50, column: 2 };
        if (width) {
            let formItemWidth = 50;
            let column = 2;
            if (width < 600) {
                formItemWidth = 100;
                column = 1;
            }
            if (width >= 600 && width < 900) {
                formItemWidth = 50;
                column = 2;
            }
            if (width >= 900 && width < 1230) {
                formItemWidth = 33.333333;
                column = 3;
            }
            if (width >= 1230 && width < 1820) {
                formItemWidth = 25;
                column = 4;
            }
            if (width >= 1820) {
                formItemWidth = 20;
                column = 5;
            }
            formItemInfo.width = formItemWidth;
            formItemInfo.column = column;
            this.setLayout(formItemInfo);
        }
    };
    // 设置表单多语
    setJson = json => {
        this.setStore(['json'], json);
    }
    // 获取多语
    getJson = () => {
        return this.get(['json']) || {};
    }

    // =========== 业务组使用api ===========
    // 取store
    getItemValue = (name, type) => {
        let value;
        // 兼容处理多语字段
        if (type) {
            let languageMeta = this.get([this.items, name, 'languageMeta']);
            // 多语字段 兼容提供对象
            if (languageMeta) {
                value = {};
                languageMeta.forEach(item => {
                    let index = item.index === '1' ? '' : item.index;
                    value[name + index] = this.get([this.items, name + index, 'fieldValue']) || { display: null, value: null };
                });
            } else {
                value = this.get([this.items, name, 'fieldValue']) || { display: null, value: null };
            }
        } else {
            value = this.get([this.items, name, 'fieldValue']) || { display: null, value: null };
        }

        return value;
    };

    // 设置Store item value
    setItemValue = (name, value, { cancel, inner = false, setAllMultiLangValue, pageScope, relationFlag = false, requestMetaByDimensionFlag = false, callback } = {}) => {
        // const prevStore = this.store;
        // this.prevStore = prevStore;
        //处理多语只清空一中语言的问题NCC-171022
        let currentItem = this.getStore([this.items, name]);
        let oldValue = this.getStore([this.items, name, 'fieldValue']);
        const timeFun = setTimeValue();
        // 翻译下函数
        if (currentItem && TIME_TYPE.has(currentItem.itemtype)) {
          value = this.getTimeTypeValue({ ...value }, currentItem, timeFun);
        }
        let newStore = this.setStore([this.items, name, 'fieldValue'], value, false);
        if (currentItem && Array.isArray(currentItem.languageMeta) && setAllMultiLangValue) {
            currentItem.languageMeta.forEach(({ index }) => {
                if (index !== 1) {
                    let realCode = name + index;
                    this.setItemValue(realCode, value, { cancel, inner, pageScope, relationFlag, callback });
                }
            });
        }

        if (!inner) {
            this.setOldValue(name, oldValue);
            if (!cancel && !relationFlag) {
                this.setStore([this.items, name, 'formBack'], value, false);
            }
        }

        if (value?.value) {
            this.setItemAttribute(name, 'verify', true, false);
        }

        this.updateItem([name]);
        // 通知下 addFormItemListener 注册的回调该更新的都要更新了
        let formId = this.getStore('mainId');
        let callbackArr = pageScope?.formEventListener?.[formId]?.[name] || [];
        callbackArr.forEach(callback => {
            let itemOldValue = oldValue?.value || '';
            let itemNewValue = value?.value || '';
            if (isFunction(callback)) {
                // shareChange 存储的是一个attrcode数组，数组中任意一个字段发生变化，调用callback，返回所有字段的值
                if (isArray(callback.shareChange)) {
                    let itemValue = [];
                    for (let index = 0; index < callback.shareChange.length; index++) {
                        const element = callback.shareChange[index];
                        if (element === name) {
                            itemValue.push({ oldValue: oldValue || {}, newValue: value || {}, attrcode: name });
                        } else {
                            let oldValue = this.getStore([this.items, element, 'fieldValue']);
                            itemValue.push({ oldValue: oldValue || {}, newValue: oldValue || {}, attrcode: element });
                        }
                    }
                    callback(itemValue);
                } else if (inner && callback.innerChange) {
                    // innerChange 表示在字段的编辑过程中触发回调，除了返回字段的值，还要返回 innerChange:true
                    itemOldValue !== itemNewValue && callback({ oldValue, newValue: value, attrcode: name, innerChange: true });
                } else {
                    // 调用API给字段赋值，返回字段的值
                    !inner && itemOldValue !== itemNewValue && callback({ oldValue, newValue: value, attrcode: name, innerChange: false });
                }
            }
        });

        // 找一下当前页面存储的维度字段是不是有变化，如果有变化，就要去用新维度重新查询模板
        let dimensionCodes = this.getStore('__dimension') || [];
        let dimensionCodeArr = dimensionCodes.map(item => item.code);
        // 两种场景需要弹窗：清空、切换组织。这两种情况在领域的编辑后会走赋值切换模板
        // 正常的字段编辑后还是要走切换模板的逻辑
        let meta = this.getStore('meta');
        if (dimensionCodeArr.length > 0) {
            if (!requestMetaByDimensionFlag || (!oldValue?.value && value?.value && inner)) {
                pageScope?.metaChange?.requestMetaByDimension(formId, callback, {
                    appcode: meta && meta[formId]?.appcode,
                    pagecode: meta && meta[formId]?.pagecode,
                });
            }
        }
        return newStore;
    };

    getOldValue = name => {
        return this.getStore([this.items, name, 'formOldValues']);
    }

    setOldValue = (name, oldValue) => {
        this.setStore([this.items, name, 'formOldValues'], oldValue, false);
    }

    // 设置关键信息区属性
    setCardItemAttribute = (formId, name, attribute, value, shouldUpdate = true, options = {}) => {
        // 加一个字段存储是否为字段控制规则修改的标识
        let { isControlRule = false } = options;
        if (attribute && typeof attribute === 'object') {
            // 批量设置
            let values = attribute;
            attribute = name;
            for (let key of Object.keys(values)) {
                this.setCardItemAttribute(key, attribute, values[key], false, options);
            }
        } else {
            // 设置单个字段
            if (this.get([this.formCardItems, formId, name])) {
                this.setStore([this.formCardItems, formId, name, attribute], value, false);
                this.setStore([this.formCardItems, formId, name, '__dirty__', attribute], true, false);
                // 字段控制规则修改过 __controlRule__ 为true 领域调用 API 修改 __controlRule__ 为false
                this.setStore([this.formCardItems, formId, name, '__controlRule__', attribute], isControlRule, false);
            } else {
                console.warn('form' + name + '不存在');
            }
        }
        shouldUpdate && this.forceUpdate();
    };

    // 获取关键信息区字段
    getCardItem = (formId, name) => {
        return this.get([this.formCardItems, formId, name]);
    };

    // 设置属性
    setItemAttribute = (name, attribute, value, shouldUpdate = true, options = {}) => {
        // 加一个字段存储是否为字段控制规则修改的标识
        let { isControlRule = false } = options;
        if (attribute && typeof attribute === 'object') {
            // 批量设置
            let values = attribute;
            attribute = name;
            for (let key of Object.keys(values)) {
                this.setItemAttribute(key, attribute, values[key], false, options);
            }
        } else {
            // 设置单个字段
            if (this.get([this.items, name])) {
                this.setStore([this.items, name, attribute], value, false);
                this.setStore([this.items, name, '__dirty__', attribute], true, false);
                // 字段控制规则修改过 __controlRule__ 为true 领域调用 API 修改 __controlRule__ 为false
                this.setStore([this.items, name, '__controlRule__', attribute], isControlRule, false);
            } else {
                console.warn('form' + name + '不存在');
            }
        }
        shouldUpdate && this.forceUpdate();
    };

    // 获取属性
    getItemAttribute = (name, attribute) => {
        return this.get([this.items, name, attribute]);
    };

    // 设置全部值
    setAllFormValue = (data = {}, copyFlag, emptyOldVal, setOldValueExceptKey, callback, pageScope, relationFlag = false) => {
        let langRelation = this.getStore([this.items, 'langRelation']);

        for (let [attrcode, value] of Object.entries(data)) {
            // 当前语言
            if (langRelation?.[attrcode] && value?.value) {
                const currentValue = data[langRelation[attrcode]] || {};
                currentValue.value = currentValue.value || value.value;
            }
        }
        let formId = this.getStore('mainId');
        // 找一下当前页面存储的维度字段是不是有变化，如果有变化，就要去用新维度重新查询模板
        let dimensionCodes = this.getStore('__dimension') || [];

        for (let [attrcode, value] of Object.entries(data)) {

            // 编辑关联项用setOldValueExceptKey，这个字段不设旧值
            this.setItemValue(attrcode, value, { cancel: false, inner: attrcode === setOldValueExceptKey, pageScope, relationFlag, requestMetaByDimensionFlag: true });
            // const prevStore = this.store;
            // this.prevStore = prevStore;
            // this.setStore([this.items, attrcode, 'fieldValue'], value, false);
        }
        // 把callback 放在获取维度模板的方法里执行，确保callback在最后
        if (dimensionCodes.length > 0) {
            let meta = this.getStore('meta');
            pageScope?.metaChange?.requestMetaByDimension(formId, callback, {
                appcode: meta && meta[formId]?.appcode,
                pagecode: meta && meta[formId]?.pagecode,
            });
        }
        this.forceUpdate();
    };

    // 获取全部值
    getAllFormValue = (id, inMeta = false) => {
        let res = {};
        if (inMeta) {
            let items = this.get([id, 'items']) || [];
            let obj = this.get([this.items]);
            for (let index = 0; index < items.length; index++) {
                const attrcode = items[index];
                res[attrcode] = obj[attrcode]['fieldValue'] || {
                    display: null,
                    value: null,
                };
            }
            return res;
        }
        for (let [attrcode, obj] of Object.entries(
            this.get([this.items]) || {},
        )) {
            if (attrcode) {
                res[attrcode] = obj['fieldValue'] || {
                    display: null,
                    value: null,
                };
            }
        }
        return res;
    };
    // 展开表单某个区域
    openArea = (name, shouldUpdate = true) => {
        let newValue = this.setStore([name, 'isunfold'], true, shouldUpdate);
        this.setStore([name, '__dirty__', 'isunfold'], true, false);
        return newValue;
    }
    // 收起表单某个区域
    closeArea = (name, shouldUpdate = true) => {
        let newValue = this.setStore([name, 'isunfold'], false, shouldUpdate);
        this.setStore([name, '__dirty__', 'isunfold'], false, false);
        return newValue;
    }

    setAreaVisible = (moduleId, visible) => {
        this.setStore([moduleId, 'areaVisible'], visible, true);
        this.setStore([moduleId, '__dirty__', 'areaVisible'], true, false);
    }

    getAreaVisible = moduleId => {
        return this.getStore([moduleId, 'areaVisible']) !== false;
    }

    // 校验表单
    isCheckNow = (autoFocus = false) => {
        let firstErrorModuleId = '',
            firstErrorTab = '',
            tabsId = this.getStore('tabsId'),
            formRelation = this.getStore('formRelation'),
            itemsMap = this.getStore([this.items]),
            requiredItems = [],
            regItems = [],
            maxItems = [],
            // switchFalse = ['switch', 'switch_browse', 'radio', 'checkbox_switch'],
            lengthTypes = ['input', 'number', 'textarea'],
            isCheckNowItems = [],
            requiredLabelAttr = [],
            errorGroup = new Set(),
            firstErrorElement,
            hasError = false;

        // 变量items 校验 不根据meta校验 meta中字段存在问题
        (this.getStore(['formList']) || []).forEach(formId => {
            if (this.getAreaVisible(formId)) {
                isCheckNowItems = isCheckNowItems.concat(this.getStore([formId])['items'] || []);
            }
        });

        isCheckNowItems.forEach(item => {
            let currentItem = itemsMap[item];
            let { label, required, visible, belongTo, reg, regMessage, fieldValue, itemtype, maxlength, attrcode, checkAutoFocus, languageMeta } = currentItem;
            if (visible) {
                let value = fieldValue?.value;
                let error = false;
                // 多语取当前语种的值，其他属性如必填、可见取模板上的
                if (itemtype === 'residtxt' && Array.isArray(languageMeta)) {
                    let multiLangIndex = languageMeta.find(lang => lang.languageCode === localeLang)?.index;
                    let currentLangIndex = multiLangIndex == '1' ? '' : multiLangIndex;
                    value = itemsMap[`${attrcode}${currentLangIndex}`]?.fieldValue?.value?.trim();
                }
                if (required && !SKIP_VALIDATE_TYPE.has(itemtype) && [null, undefined, ''].includes(value)) {
                    error = true;
                    requiredItems.push(label);
                    requiredLabelAttr.push({ 'attrcode': attrcode, 'display': label })
                    !firstErrorElement && (firstErrorElement = attrcode);
                }
                if (value && reg) {
                    let result = false;
                    // 复杂的身份证校验，正则搞不定，传进来一个function
                    if (Object.prototype.toString.call(reg) === '[object Function]') {
                        result = !reg(value);
                    }
                    // 普通的正则校验
                    if (Object.prototype.toString.call(reg) === '[object RegExp]') {
                        result = !reg.test(value);
                    }
                    if (result) {
                        error = true;
                        regItems.push({ label, regMessage });
                        !firstErrorElement && (firstErrorElement = attrcode);
                    }
                }

                let valLength = 0;
                // 将字符串转换为二进制数据计算长度
                let encoder;
                if (typeof value === 'string' && maxlength && lengthTypes.includes(itemtype)) {
                    if (window.TextEncoder) {
                        encoder = new TextEncoder();
                        valLength = value.split('').reduce((total, pre) => { return total + encoder.encode(String(pre)).length; }, 0);
                        // valLength = encoder.encode(String(value)).length;
                    } else {
                        // 中文下有个特殊字符 数据库里占用的是两个字符
                        valLength = String(value).replace(
                            /\·|[^\x00-\xff]/gi,
                            '---',
                        ).length;
                    }
                }
                
                if (maxlength && lengthTypes.includes(itemtype) && value && valLength > maxlength) {
                    error = true;
                    maxItems.push(label);
                    !firstErrorElement && (firstErrorElement = attrcode);
                }

                this.setItemAttribute(item, 'verify', !error, false);

                if (error) {
                    // 展开有错误的分组，并定位到第一个含有错误字段的页签
                    if (!firstErrorModuleId) {
                        firstErrorModuleId = belongTo;
                    }
                    errorGroup.add(belongTo);
                } else {
                    if (checkAutoFocus) {
                        this.setItemAttribute(item, 'autoFocus', false, false);
                        this.setItemAttribute(item, 'checkAutoFocus', false, false);
                    }
                }
            }
        });

        autoFocus && firstErrorElement && PubSub.publish('autoFocus', { data: firstErrorElement, formId: this.getStore('mainId') });

        // 找到第一个含有错误字段的页签
        if (tabsId.includes(firstErrorModuleId)) {
            firstErrorTab = firstErrorModuleId;
        } else {
            firstErrorTab = tabsId.find(tabId => {
                return Array.isArray(formRelation[tabId]) && formRelation[tabId].includes(firstErrorModuleId);
            });
        }

        [...errorGroup].forEach(moduleId => {
            hasError = true;
            this.openArea(moduleId, false);
        });

        firstErrorTab && this.setStore('activeTab', firstErrorTab, false);

        this.forceUpdate();
        return { requiredItems, regItems, maxItems, hasError, requiredLabelAttr };
    }

    // 取消操作
    cancel = () => {
        let items = this.get([this.items]) || {};
        for (let key of Object.keys(items)) {
            this.setStore([this.items, key, 'fieldValue'], this.get([this.items, key, 'formBack']), false);
            this.setStore([this.items, key, 'verify'], true, false);
            this.setStore([this.items, key, 'autoFocus'], false, false);
        }
        this.setStatus('browse');
        this.forceUpdate();
    }

    clearAllVerify = () => {
        let items = this.get([this.items]) || {};
        for (let key of Object.keys(items)) {
            this.setStore([this.items, key, 'verify'], true, false);
        }
    }

    // 清空数据
    emptyAllFormValue = (exceptArr = [], cancel = true, pageScope) => {
        let switchFalse = ['switch', 'switch_browse', 'checkbox_switch'];
        let itemsMap = this.get([this.items]);
        let context = this.get('context') || {};
        const timeFun = setTimeValue();
        let formId = this.getStore('mainId');
        // 清空数据这里也要重置维度，恢复到默认模版，也不一定是默认模板，还得看用默认值查出来是哪个模板
        let dimensionCodes = this.getStore('__dimension') || [];

        itemsMap && Object.keys(itemsMap).forEach(item => {
            let initialvalue = this.getStore([this.items, item, 'initialvalue']);
            // 判断下模板返回的 initialvalue ，如果是空对象，按照之前的 null 处理
            let isEmptyObj = Object.keys(initialvalue || {}).length === 0 && (initialvalue || {}).constructor === Object;
            initialvalue = isEmptyObj ? null : initialvalue || null;
            // 用户自定义属性，isuserdef为true不设置默认值
            if (!exceptArr.includes(item)) {
                let oldValue = { ...this.getStore([this.items, item, 'fieldValue']) };

                if (switchFalse.includes(itemsMap[item].itemtype)) {
                    let defaultValue = initialvalue || {
                        display: (this.getStore(['json']) || {})['page-form-0004'],
                        value: false,
                    };
                    let templateValue = initialvalue || {
                        display: null,
                        value: null,
                    };
                    // isuserdef 用户自定义属性 组件默认值不生效，模板默认值生效
                    this.setStore([this.items, item, 'fieldValue'], itemsMap[item].isuserdef ? templateValue : defaultValue, false);
                } else {
                    // if(itemsMap[item].itemtype == 'residtxt'){
                    //     this.setStore([this.items, item, 'fieldValue'], {
                    //         value: {},
                    //         display: null,
                    //     }, false);
                    // }else {
                    //设置默认值
                    if (TIME_TYPE.has(itemsMap[item].itemtype)) {
                        initialvalue = this.getTimeTypeValue(initialvalue, itemsMap[item], timeFun);

                    } else if (itemsMap[item].itemtype === 'refer') {
                        // 参照组件 fx 函数处理 如 “#mainorg#""
                        initialvalue = getFxExpression(initialvalue || {}, context);
                    } else if (itemsMap[item].itemtype === 'number') {
                        // 数值类型 处理下
                        initialvalue = getNumberValue(initialvalue || {});
                    } else {
                        initialvalue = initialvalue || {
                            display: null,
                            value: null,
                        };
                    }
                    this.setStore([this.items, item, 'fieldValue'], initialvalue ? initialvalue : {
                        value: null,
                        display: null,
                    }, false);
                    // }
                }
                if (cancel) {
                    this.setStore([this.items, item, 'formBack'], {
                        value: null,
                        display: null,
                    }, false);
                }

                let nextValue = { ...this.getStore([this.items, item, 'fieldValue']) };
                // 通知下 addFormItemListener 注册的回调该更新的都要更新了
                let formId = this.getStore('mainId');
                let callbackArr = pageScope?.formEventListener?.[formId]?.[item] || [];
                callbackArr.forEach(callback => {
                    let itemOldValue = oldValue?.value || '';
                    let itemNewValue = nextValue?.value || '';
                    itemOldValue !== itemNewValue && isFunction(callback) && callback({ oldValue, newValue: nextValue, attrcode: item });
                });
            }
        });
        let meta = this.getStore('meta');
        pageScope?.metaChange?.requestMetaByDimension(formId, null, {
            appcode: meta && meta[formId]?.appcode,
            pagecode: meta && meta[formId]?.pagecode,
        });
        this.forceUpdate();
        // console.log(this.store, this)
    }

    // 清空表单数据，不设置默认值
    clearFormValue = (params, pageScope) => {
        let formId = this.getStore('mainId');
        const { exceptArr = [] } = params;
        let itemsMap = this.get([this.items]);
        itemsMap && Object.keys(itemsMap).forEach(item => {
            !exceptArr.includes(item) && this.setStore([this.items, item, 'fieldValue'], null, false);
        });
        let meta = this.getStore('meta');
        pageScope?.metaChange?.requestMetaByDimension(formId, null, {
            appcode: meta && meta[formId]?.appcode,
            pagecode: meta && meta[formId]?.pagecode,
        });
        this.forceUpdate();
    }

    // 表单重置操作
    reset = () => {
        this.store = {};
        // this.wrapper && this.wrapper.refresh();
    };

    // 获取当前区域 谨慎操作
    getCtx = () => { };

    // 设置当前区域
    setCtx = ctx => {
        this.ctx = ctx;
    };

    // 重置meta 
    /**
     * @description: setmeta 是否需要ID store初始化应该具有ID的 createform 时记录
     * @param {type} 
     * @return: 
     */
    setMeta = (meta, id, shouldUpdate = true, context, pageScope, clearStoreMeta) => {
        console.log(`Form ${id}'s meta: `, meta);
        // this.setStore(['meta'], meta, false)
        let currentID = id || this.getStore('mainId');
        let activeTab = this.getStore(['activeTab'], id);
        this.setStore(['_attachment'], [], false);
        let newContext = { ...ViewModel.getContext(), ...context };
        this.setInitialValues({ meta, formId: currentID, context: newContext, pageScope, clearStoreMeta });
        if (shouldUpdate) {
            this.forceUpdate(() => {
                activeTab && this.setStore(['activeTab'], activeTab);
            });
        } else {
            activeTab && this.setStore(['activeTab'], activeTab);
        }

    }

    /**
     * @description: 替换组件
     * @param {type} 
     * @return: 
     */
    replaceItem = (attrcode, itemDom) => {
        this.setStore(['replaceItem', attrcode], itemDom);
    }

    getReplaceItem = attrcode => {
        return this.getStore(['replaceItem', attrcode]);
    }
    // 外层wrapper 暂时 重置 reset时使用 可以把reset 抽到每一个formitem上面
    setWrapper = ctx => {
        this.wrapper = ctx;
    };

    // 获取items // 支持主子表ID; 兼容容错
    getMetaItems = id => {
        let items = (this.getStore([id]) && this.getStore([id])['items']) || [];
        let res = items.map(item => {
            let { __dirty__, __origin__, ...itemFromStore } = this.getStore([this.items, item]);
            let itemFromOrigin = ['disabled', 'visible', 'required', 'verify'].reduce((o, attribute) => {
                o[attribute] = this.getStore([this.items, item, '__origin__', attribute]);
                return o;
            }, {});
            return { ...itemFromStore, ...itemFromOrigin };
        });
        return res;
    }
    // store meta数据销毁 

    initMeta = () => {
        // 暂时这样处理
        this.store = {};
        this.forceUpdate();
    }

    // 设置监听事件
    setEventListener = (eventName, callback) => {
        let eventListenerObj = this.getStore(['addEventListenerList']) || {};
        let eventCallback = eventListenerObj[eventName] || [];
        eventCallback.push(callback);
        this.setStore(['addEventListenerList'], { ...eventListenerObj, [eventName]: eventCallback });
    }
    // 获取监听事件
    getEventListener = () => {
        let eventListenerObj = this.getStore(['addEventListenerList']);
        return eventListenerObj || {};
    }

    // 表单状态切换到浏览态时清空添加的autoFocus属性
    clearAutoFocus = () => {
        let itemsMap = this.getStore([this.items]);
        let storeItems = [];
        // 取items逻辑参考 isCheckNow
        (this.getStore(['formList']) || []).forEach(formId => {
            if (this.getAreaVisible(formId)) {
                storeItems = storeItems.concat(this.getStore([formId])['items'] || []);
            }
        });

        storeItems.forEach(item => {
            let currentItem = itemsMap[item];
            let { checkAutoFocus = false } = currentItem;
            if (checkAutoFocus) {
                this.setItemAttribute(item, 'autoFocus', false, false);
                this.setItemAttribute(item, 'checkAutoFocus', false, false);
            }
        });
    }

    // 处理时间格式的默认值
    getTimeTypeValue = (initialvalue, formItem, timeFun) => {
        if (initialvalue?.value?.includes('#')) {
            if (initialvalue?.value?.includes(',')) {
                // 日期组件特殊默认值处理 如 "#month(-1),10#"
                initialvalue = { ...initialvalue, value: timeFun[initialvalue.value].value(formItem) };
            } else if (initialvalue?.value?.includes('my') && (formItem.itemtype === 'datetimepicker' || formItem.itemtype === 'NCTZDatePickClientTime')) {
                // 日期组件特殊默认值处理 如 "#day(0)# 00:00:00"
                let [dateValue, timeValue] = initialvalue.value.split(' ');
                dateValue = getFunctionValue(dateValue.replace('my', ''), { ...formItem, range: formItem.itemtype.includes('range'), singleValue: true });
                initialvalue = { ...initialvalue, value: dateValue + timeValue };
            } else if (initialvalue?.value === "#bizDateTime#") {
                if (formItem.itemtype === "timepicker") {
                    initialvalue.value = BUSINESSDATE?.slice(11);
                } else {
                    initialvalue.value = BUSINESSDATE;
                }
            } else {
              // 日期组件特殊默认值处理 如 "#day(0)#"
              // initialvalue = { ...initialvalue, value: getFunctionValue(initialvalue.value, { ...formItem, range: formItem.itemtype.includes('range'), singleValue: true }) };
              let dateValue = getFunctionValue(initialvalue.value, {
                ...formItem,
                range: formItem.itemtype.includes("range"),
                singleValue: true,
              });
              // 使用日期组件的方法 返回的只有日期没有时间时，需要加上时分秒
              if (
                dateValue?.indexOf(" ") === -1 &&
                formItem.itemtype !== "timepicker"
              ) {
                let defaultBaseTime = getBaseTime();
                dateValue = dateValue.concat(" ").concat(defaultBaseTime);
              }
              initialvalue = { ...initialvalue, value: dateValue };
            }
        } else if (initialvalue?.value === '@BIZDATE') {
            // 日期组件特殊默认值处理 "@BIZDATE"
            // initialvalue = { ...initialvalue, value: BUSINESSDATE };
            if (formItem.itemtype === 'timepicker') {
                initialvalue.value = BUSINESSDATE?.slice(11);
            } else {
                initialvalue.value = BUSINESSDATE;
            }
        } else {
            //没有时间部分，需要拼上，不然到了serverToLocal接口，会默认用当前时间，时区改变时有影响
            if (initialvalue?.value && initialvalue?.value?.indexOf(' ') === -1 && (formItem.itemtype !== 'timepicker' && formItem.itemtype !== 'datePickerNoTimeZone'))
                 {
                let defaultBaseTime = getBaseTime();
                initialvalue.value = initialvalue.value.concat(' ').concat(defaultBaseTime);
            }
            initialvalue = initialvalue || {
                display: null,
                value: null,
            };
        }
        return initialvalue;
    }
}

export const useForm = hookFactory(FormStore);

